import React, { useState } from 'react';
import { toAbsoluteUrl } from '../functions';

export function Watermark(props) {
    const { database } = props;
    const [logoError, setLogoError] = useState(false);

    // Detect portal from hostname (case-insensitive check)
    const hostname = typeof window !== 'undefined' ? window.location.hostname.toLowerCase() : '';
    const isReadingPlex = hostname.includes('readingplex');

    let message = '';
    switch (database) {
        case 'MathPlex':
            message = '';
            break;
        case 'MathPlexTest':
            message = 'Heads up! You are working on the test database.';
            break;
        case undefined:
        case null:
            break;
        default:
            message = `Unknown database "${database}"!`;
            break;
    }

    // Determine which logo to show based on portal
    const logoPath = isReadingPlex
        ? "/media/logos/readingplex-logo.png"
        : "/media/logos/lightshort.png";

    const logoAlt = isReadingPlex
        ? "ReadingPlex logo"
        : "MathPlex logo";

    // If ReadingPlex logo fails to load, don't show any logo
    const handleLogoError = () => {
        if (isReadingPlex) {
            setLogoError(true);
        }
    };

    // Don't render if ReadingPlex logo failed to load
    if (isReadingPlex && logoError) {
        return message ? (
            <div className="fixed text-md text-mpLRed z-[100000] bottom-8 left-8 pointer-events-none">
                <div className="flex flex-row items-center">
                    {message}
                </div>
            </div>
        ) : null;
    }

    const logo = (
        <img
            src={toAbsoluteUrl(logoPath)}
            className="h-12 opacity-70"
            alt={logoAlt}
            onError={handleLogoError}
        />
    );

    return (
        <div className="fixed text-md text-mpLRed z-[100000] bottom-8 left-8 pointer-events-none">
            <div className="flex flex-row items-center">
                {logo} &nbsp; {message}
            </div>
        </div>
    );
}
